import {action} from "mobx";
import i18n from "../i18n";
import ticketTypeService from "../services/ticketTypeService";
import appStore from "./appStore";

class ticketTypeStore {
    @action getTicketTypes = async params => {
        const resultOfRequest = await ticketTypeService.getTicketTypes(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getTicketTypeOptions = async category => {
        const resultOfRequest = await ticketTypeService.getTicketTypeOptions(category);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createTicketType = async params => {
        const resultOfRequest = await ticketTypeService.createTicketType(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("ticketTypes.messages.created", {ns: "tickets"})
        });
        return resultOfRequest.data;
    };

    @action updateTicketType = async (id, params) => {
        const resultOfRequest = await ticketTypeService.updateTicketType(id, params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("ticketTypes.messages.updated", {ns: "tickets"})
        });
        return resultOfRequest.data;
    };

    @action deleteTicketType = async id => {
        const resultOfRequest = await ticketTypeService.deleteTicketType(id);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("ticketTypes.messages.deleted", {ns: "tickets"})
        });
        return resultOfRequest.data;
    };
}

export default new ticketTypeStore();
